export default "__VITE_ASSET__c250a2d8__"